import { Component, OnInit } from '@angular/core';
import { FiltrosProducaoRetornoService } from '../../../../filters/filtros-producaoretorno.service';
import { ProducaoRetornoService } from '../../../../services/producaoretorno.service';
import { ProducaoAgricolaParametros } from '../../../../types/ProducaoAgricolaParametros.type';

@Component({
  selector: 'app-producaoagricola',
  templateUrl: './producaoagricola.component.html',
  styleUrl: './producaoagricola.component.css',
})
export class ProducaoAgricolaComponent implements OnInit {
  producoesParametros: ProducaoAgricolaParametros[] = [];
  totalRecordsParametros: number = 0;
  loadingParametros: boolean = false;

  instancia: string = '';

  constructor(
    private producaoRetornoService: ProducaoRetornoService,
    private filterService: FiltrosProducaoRetornoService
  ) {}

  ngOnInit() {
    this.producoesParametros = [];
    this.getFiltros();
  }

  getFiltros() {
    this.filterService.currentInstancia.subscribe((instancia) => {
      this.instancia = instancia;
      this.carregarParametros();
    });
  }

  carregarParametros() {
    if (this.instancia != '') {
      this.loadingParametros = true;
      this.producaoRetornoService
        .getProducaoAgricolaParametros(0, 1000, 'empresa', 'asc', this.instancia)
        .subscribe({
          next: (data) => {
            this.producoesParametros = data.content ?? data;
            this.totalRecordsParametros = data.totalElements ?? this.producoesParametros.length;
            this.loadingParametros = false;
          },
          error: () => {
            this.loadingParametros = false;
          }
        });
    }
  }
}
